
import { Injectable } from '@angular/core';
import ApiResponse from 'models/api-response/api-response.model';
import Log from 'models/log/log.model';
import PaginatedList from 'models/paginated-list/paginated-list.model';
import Project from 'models/project/project.model';
import TicketCategory from 'models/ticket-category/ticket-category.model';
import { ApiRequestService } from 'services/api-request/api-request.service';
import { LogService } from 'services/log/log.service';

@Injectable({
  providedIn: 'root',
})
export class TicketCategoryService {
 
  constructor(
    public apiRequestService: ApiRequestService,
    public logService: LogService,
  ) { }

  public async create(instance: TicketCategory): Promise<TicketCategory> {
    return new Promise((resolve: (r: TicketCategory) => any, reject: (e: Error) => any) => {
        this.apiRequestService.post('/ticketcategory/create', {
            // id: instance.id,
            name: instance.name,
            icon: instance.icon,
            color: instance.color,
            project: instance.project.id,
        }).subscribe({
            next: async (res: ApiResponse<TicketCategory>) => {
                if (!res.success) {
                    await this.logService.create(new Log({
                        description: 'requestError: ' + JSON.stringify(res),
                        event: 'serviceError',
                        performer: 'TicketCategoryService.create',
                        type: 'error',
                      }));
                    return reject(new Error('requestError'));
                }
                return resolve(new TicketCategory(res.data));
            },
            error: async error => {
              await this.logService.create(new Log({
                description: error,
                event: 'serviceError',
                performer: 'TicketCategoryService.create',
                type: 'error'
              }));
              return reject(new Error('requestError'));
            }
          });
    });
  }

  public async get(id: string): Promise<TicketCategory> {
    return new Promise((resolve: (r: TicketCategory) => any, reject: (e: Error) => any) => {
        this.apiRequestService.get('/ticketcategory/get/' + id).subscribe({
          next: async (res: ApiResponse<TicketCategory>) => {
            if (!res.success) {
                await this.logService.create(new Log({
                    description: 'requestError: ' + JSON.stringify(res),
                    event: 'serviceError',
                    performer: 'TicketCategoryService.get',
                    type: 'error'
                  }));
                return reject(new Error('requestError'));
            }
            return resolve(new TicketCategory(res.data));
          },
          error: async error => {
            console.log(error);
            await this.logService.create(new Log({
              description: error,
              event: 'serviceError',
              performer: 'TicketCategoryService.get',
              type: 'error'
            }));
            return reject(new Error('requestError'));
          }
        });
    });
  }

  public async list(project: Project): Promise<TicketCategory[]> {
    return new Promise((resolve: (r: TicketCategory[]) => any, reject: (e: Error) => any) => {
        this.apiRequestService.get('/ticketcategory/list/' + project.id).subscribe({
          next: async (res: ApiResponse<PaginatedList<TicketCategory>>) => {
            if (!res.success) {
                await this.logService.create(new Log({
                    description: 'requestError: ' + JSON.stringify(res),
                    event: 'serviceError',
                    performer: 'TicketCategoryService.get',
                    type: 'error'
                  }));
                return reject(new Error('requestError'));
            }
            const arr: TicketCategory[] = [];
            for (let i = 0; i < res.data.docs.length; i++) {
              arr.push(new TicketCategory(res.data.docs[i]));
            }
            return resolve(arr);
          },
          error: async error => {
            console.log(error);
            await this.logService.create(new Log({
              description: error,
              event: 'serviceError',
              performer: 'TicketCategoryService.get',
              type: 'error'
            }));
            return reject(new Error('requestError'));
          }
        });
    });
  }

  public async update(instance: TicketCategory): Promise<TicketCategory> {
    return new Promise((resolve: (r: TicketCategory) => any, reject: (e: Error) => any) => {
        this.apiRequestService.post('/ticketcategory/update/', {
          id: instance.id,
          icon: instance.icon,
          color: instance.color,
          name: instance.name,
        }).subscribe({
          next: async (res: ApiResponse<TicketCategory>) => {
              if (!res.success) {
                  await this.logService.create(new Log({
                      description: 'requestError: ' + JSON.stringify(res),
                      event: 'serviceError',
                      performer: 'TicketCategoryService.update',
                      type: 'error'
                    }));
                  return reject(new Error('requestError'));
              }
              return resolve(new TicketCategory(res.data));
          },
          error: async error => {
            console.log(error);
            await this.logService.create(new Log({
              description: error,
              event: 'serviceError',
              performer: 'TicketCategoryService.update',
              type: 'error'
            }));
            return reject(new Error('requestError'));
          }
        });
    });
  }

  public async delete(instance: TicketCategory): Promise<boolean> {
    return new Promise((resolve: (r: boolean) => any, reject: (e: Error) => any) => {
        this.apiRequestService.delete('/ticketcategory/' + instance.id, {}).subscribe({
          next: async (res: ApiResponse<boolean>) => {
              if (!res.success) {
                  await this.logService.create(new Log({
                      description: 'requestError: ' + JSON.stringify(res),
                      event: 'serviceError',
                      performer: 'TicketCategoryService.delete',
                      type: 'error'
                    }));
                  return reject(new Error('requestError'));
              }
              return resolve(res.data);
          },
          error: async error => {
            console.log(error);
            await this.logService.create(new Log({
              description: error,
              event: 'serviceError',
              performer: 'TicketCategoryService.delete',
              type: 'error'
            }));
            return reject(new Error('requestError'));
          }
        });
    });
  }
}
